@if (!autoComplete) {
  <dcr-text-field
    type="search"
    class="[ w-full ]"
    [value]="currentValue"
    [disabled]="disabled"
    (change)="updateCurrentValue($event.target.value)"
    (input)="updateCurrentValue($event.target.value)"
    [placeholder]="placeholder"
    [clearable]="showReset"
    (clear)="reset()"
    data-cy="search-term-filter"
  ></dcr-text-field>
} @else {
  <mat-form-field class="mat-form-field-no-hint" data-cy="search-term-filter">
    <mat-label>{{ placeholder }}</mat-label>
    <div class="[ flex gap-2xs -m-b-2xs ]">
      <input
        [disabled]="disabled"
        [autofocus]="getAutoFocusValue()"
        [(ngModel)]="currentValue"
        [matAutocomplete]="auto"
        (keyup.enter)="onChange(); trigger.closePanel()"
        (input)="onTextChange(); getAutoCompleteValues()"
        #trigger="matAutocompleteTrigger"
        matInput
        data-cy="input-text-field"
        />
      @if (showReset) {
        <dcr-inline-icon-button
          [disabled]="disabled"
          class="search-term-filter__reset-icon"
          [ngClass]="{ 'search-term-filter__reset-icon--visible': currentValue }"
          aria-label="Wissen"
          clickStopPropagation
          (click)="reset()"
          icon="search:close"
          data-cy="btn-clear-search-term-filter"
          >
        </dcr-inline-icon-button>
      }
      @if (!emitOnTextChange || showMagnifier) {
        <dcr-inline-icon-button
          class="search-term-filter__search-icon"
          [disabled]="disabled"
          (click)="onChange()"
          icon="search:magnifier"
          data-cy="btn-search-term-filter"
        ></dcr-inline-icon-button>
      }
    </div>
    <mat-autocomplete (optionSelected)="onChange()" #auto="matAutocomplete" class="search-term__autocomplete">
      @for (option of autoCompleteValues; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}

